import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '国产剧', href: '/category/chinese' },
  { label: '韩剧', href: '/category/korean' },
  { label: '美剧', href: '/category/american' },
  { label: '日剧', href: '/category/japanese' },
  { label: '动漫', href: '/category/anime' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-2-line text-white text-lg w-5 h-5 flex items-center justify-center"></i>
            </div>
            <span className="text-xl font-heading text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
              窝窝影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="px-3 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索剧集..."
                className="w-48 px-3 py-1.5 pl-9 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:bg-background-50 transition-all duration-200"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`w-5 h-5 flex items-center justify-center ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40">
          <div className="flex flex-col p-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="px-4 py-3 rounded-lg text-base font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-all duration-200"
              >
                {link.label}
              </Link>
            ))}
            <div className="mt-3 px-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索剧集..."
                  className="w-full px-4 py-2.5 pl-10 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all duration-200"
                />
                <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}